import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {PageDescription, AnchorLinks, AnchorLink, InlineNotification, MiniCard, Bash, Code, Release, ReleaseChanges, ReleaseChange, Feedback} from 'components';
function _createMdxContent(props) {
  const _components = {
    a: "a",
    p: "p",
    strong: "strong",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(Release, {
      title: "Braiins Manager",
      date: [2024, 10, 14],
      children: [_jsxs(_components.p, {
        children: ["We’re excited to announce that ", _jsx(_components.strong, {
          children: "Braiins Manager"
        }), " is now open to everyone! Register at ", _jsx(_components.a, {
          href: "https://manager.braiins.com/sign-up",
          children: "manager.braiins.com/sign-up"
        }), "."]
      }), _jsx(ReleaseChanges, {
        title: "Free Access",
        children: _jsxs(ReleaseChange, {
          type: "feature",
          children: ["Braiins Manager is now ", _jsx(_components.strong, {
            children: "free for everyone"
          }), ". For more details, check our ", _jsx(_components.a, {
            href: "https://academy.braiins.com/en/terms-and-policies/",
            children: "terms and policies"
          }), "."]
        })
      }), _jsxs(ReleaseChanges, {
        title: "Key Updates",
        children: [_jsxs(ReleaseChange, {
          type: "feature",
          children: ["New and easy ", _jsx(_components.strong, {
            children: "sign-up"
          }), " process for account creation."]
        }), _jsxs(ReleaseChange, {
          type: "feature",
          children: [_jsx(_components.strong, {
            children: "Navigation wizard"
          }), " added for simpler onboarding."]
        }), _jsxs(ReleaseChange, {
          type: "feature",
          children: ["Complete redesign of the ", _jsx(_components.a, {
            href: "/en/braiins-manager/scanner",
            children: _jsx(_components.strong, {
              children: "Scanner"
            })
          }), "."]
        }), _jsxs(ReleaseChange, {
          type: "feature",
          children: ["All-new ", _jsx(_components.a, {
            href: "/en/braiins-manager/sitemap",
            children: _jsx(_components.strong, {
              children: "Sitemap"
            })
          }), " component (old version to be deprecated soon)."]
        }), _jsx(ReleaseChange, {
          type: "feature",
          children: "Multiple performance improvements and bug fixes."
        })]
      })]
    }), "\n", _jsx(Release, {
      title: "Braiins Manager",
      date: [2024, 3, 25],
      children: _jsxs(_components.p, {
        children: ["Initial release of ", _jsx(_components.strong, {
          children: "Braiins Manager"
        }), ", new software product from Braiins. Braiins Manager is farm management platform for managing large and small mining data centers, participate in demand response programs and more. Visit offical website ", _jsx(_components.a, {
          href: "https://braiins.com/manager",
          children: "https://braiins.com/manager"
        }), " for more details and apply for the early access."]
      })
    }), "\n", _jsx(Feedback, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
